import React from 'react';
import Layout from '../../components/Layout/Layout';
import BookingContainer from './BookingContainer';
import SubNavBar from '../../components/SubNavBar/SubNavBar';


async function action({ params, store, query, pathname }) {
    const title = store.getState().siteSettings?.data?.siteTitle
    const description = store.getState().siteSettings?.data?.metaDescription;
    const id = Number(params?.id);

    let isAuthenticated = store.getState().runtime.isAuthenticated;

    if (!isAuthenticated) {
        // Auth-expired / not-logged-in: route to the home login modal preserving the intended path
        // (?login=1&return=<path>) so post-login returns here, instead of dumping the user to home.
        const returnPath = pathname || `/booking/${params?.id ?? ''}`;
        return { redirect: '/?login=1&return=' + encodeURIComponent(returnPath) }
    }

    return {
        title,
        description,
        component: (
            <Layout>
                <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
                    {isAuthenticated && <SubNavBar />}
                    <BookingContainer id={id} />
                </div>
            </Layout>
        ),
    };
}

export default action;